//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


export default {
  props: {
    column1Narrow: Boolean,
    snapshot: Object
  },
  computed: {
    datasheetFile () {
      if (this.snapshot.datasheet) {
        return this.snapshot.datasheet
      } else if (this.snapshot.product && this.snapshot.product.datasheet && this.snapshot.product.datasheet.file) {
        return this.snapshot.product.datasheet.file
      } else {
        return null
      }
    }
  }
}

